import { formatDate } from 'lib/DatePicker/DateRangePicker/DateRangePicker';

export const formatChipDate = ({
  startDate,
  endDate,
}: {
  startDate: Date | string | null;
  endDate: Date | string | null;
}): string => `${startDate && formatDate(new Date(startDate))} - ${endDate && formatDate(new Date(endDate))}`;
